import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";

import AppRoutes from "routes/AppRoutes";

// ScrollToTop component to handle scroll on route change
function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname]);
  return null;
}

function DeferredSeo() {
  const location = useLocation();
  const [Seo, setSeo] = useState<React.ComponentType | null>(null);

  useEffect(() => {
    if (Seo) return;

    const loadSeo = () => {
      void import('components/Seo').then(({ default: SeoComponent }) => {
        setSeo(() => SeoComponent);
      });
    };

    // The pre-rendered document already has complete metadata for the home
    // page. Keep every route's SEO schema out of the initial bundle, but load
    // it before or as soon as a visitor navigates within the SPA.
    if (location.pathname !== '/') {
      loadSeo();
      return;
    }

    window.addEventListener('pointerdown', loadSeo, { once: true, passive: true });
    window.addEventListener('keydown', loadSeo, { once: true });
    return () => {
      window.removeEventListener('pointerdown', loadSeo);
      window.removeEventListener('keydown', loadSeo);
    };
  }, [Seo, location.pathname]);

  return Seo ? <Seo /> : null;
}

function App() {
  return (
    <Router>
      <DeferredSeo />
      <ScrollToTop />
      <AppRoutes />
    </Router>
  );
}

export default App;
